import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1411.8238,9.99999997e-05 C1442.9948,9.99999997e-05 1468.2938,25.2991 1468.2938,56.4711 L1468.2938,56.4711 L1468.2938,112.9411 L1637.7058,112.9411 C1731.1088,112.9411 1807.1178,188.9511 1807.1178,282.3531 L1807.1178,282.3531 L1807.1178,1920.0001 L112.9998,1920.0001 L112.9998,282.3531 C112.9998,188.9511 189.0088,112.9411 282.4118,112.9411 L282.4118,112.9411 L451.8228,112.9411 L451.8228,56.4711 C451.8228,25.2991 477.1228,9.99999997e-05 508.2938,9.99999997e-05 C539.4658,9.99999997e-05 564.7648,25.2991 564.7648,56.4711 L564.7648,56.4711 L564.7648,112.9411 L1355.3528,112.9411 L1355.3528,56.4711 C1355.3528,25.2991 1380.6518,9.99999997e-05 1411.8238,9.99999997e-05 Z M1694.1758,564.7051 L225.9418,564.7051 L225.9418,1807.0581 L1694.1758,1807.0581 L1694.1758,564.7051 Z M451.8228,225.8821 L282.4118,225.8821 C251.3528,225.8821 225.9418,251.1811 225.9418,282.3531 L225.9418,282.3531 L225.9418,451.7651 L1694.1758,451.7651 L1694.1758,282.3531 C1694.1758,251.1811 1668.7648,225.8821 1637.7058,225.8821 L1637.7058,225.8821 L1468.2938,225.8821 L1468.2938,282.3531 C1468.2938,313.5251 1442.9948,338.8241 1411.8238,338.8241 C1380.6518,338.8241 1355.3528,313.5251 1355.3528,282.3531 L1355.3528,282.3531 L1355.3528,225.8821 L564.7648,225.8821 L564.7648,282.3531 C564.7648,313.5251 539.4658,338.8241 508.2938,338.8241 C477.1228,338.8241 451.8228,313.5251 451.8228,282.3531 L451.8228,282.3531 L451.8228,225.8821 Z M959.5054,1416.6211 C877.1714,1416.6211 817.9904,1382.1741 765.1334,1320.7341 L674.3294,1404.0851 C736.5594,1479.0771 828.6064,1532.1601 957.4724,1532.1601 C1111.7504,1532.1601 1216.3344,1435.3691 1216.3344,1300.9701 L1216.3344,1298.9361 C1216.3344,1164.5361 1110.7334,1108.2921 998.8094,1094.7381 L1204.7014,886.4751 L1204.7014,790.5881 L715.5524,790.5881 L715.5524,902.0601 L1035.6284,902.0601 L835.9474,1111.4541 L857.0674,1191.6421 L917.3784,1191.6421 C1020.8324,1191.6421 1087.4674,1232.1881 1087.4674,1304.0181 L1087.4674,1306.1651 C1087.4674,1372.8001 1032.4654,1416.6211 959.5054,1416.6211",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCalendarDaysLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCalendarDaysLine, _Component);

  var _super = _createSuper(IconCalendarDaysLine);

  function IconCalendarDaysLine() {
    _classCallCheck(this, IconCalendarDaysLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCalendarDaysLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCalendarDays",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCalendarDaysLine.displayName = "IconCalendarDaysLine";
  return IconCalendarDaysLine;
}(Component);

IconCalendarDaysLine.glyphName = 'calendar-days';
IconCalendarDaysLine.variant = 'Line';
IconCalendarDaysLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCalendarDaysLine;
export { IconCalendarDaysLine };